import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { navigationSession } from './utils/constant';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // If this is a hard refresh (JS session reset), prioritize top scroll
    if (!navigationSession.isStarted) {
      window.scrollTo(0, 0);
      return;
    }

    // Only scroll to top if there isn't a specific section target in the state
    if (!location.state?.fromSection && !location.state?.scrollTo) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.state]);

  return null;
}

export default ScrollToTop;